(ns ui.components.collapse.view
  (:require
   [reagent.core :as r]
   ["react-collapse" :as react-collapse :refer [Collapse UnmountClosed]]))

(defn adapt
  [component]
  (try
    (r/adapt-react-class component)
    (catch js/Object e
      (prn (.-message e)))))

(def collapse (adapt Collapse))
(def collapse-unmount-closed (adapt UnmountClosed))


(defn view
  [{:keys [open?]} content]
  (let []
    [collapse
     {:isOpened open?}
     content]))
